import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { ICING_LEGEND } from './icing.legend';
import { ICING_PRODUCT_DATA } from './icing.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class IcingPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(ICING_PRODUCT_DATA, {
    legend: ICING_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
